// A16 — THE NEXT-EVENT DATE. Brief 65 (brief 50 §4), the twelfth of the sixteen.
//
// The sort key both matter lists use for "next event": the earliest event on or
// after today belonging to this matter, as `yyyy-MM-dd` plus its time — or
// `99:99` when it has none, so an all-day event sorts after a timed one on the
// same day. `null` when there is no such event.
//
//   src/views/CaseView.tsx:5671-5682@8fdbbd6c x src/views/CollectiveCaseView.tsx:2724-2735@8fdbbd6c  92.1%
//
// TWO DIFFERENCES, TWO PARAMETERS (§2), proved by diffing the two twelve-line
// regions with those two names normalised — they diff EMPTY:
//
//   the owner key   `a.caId` / `a.ccId`
//   the today string `todayStrCa` / `todayStrCc`
//
// Both are passed rather than derived. The today string in particular is A20's
// candidate; taking it as an argument here is what keeps these two extractions
// independent of each other, which is what makes either revertable on its own.
export const nextEventDate = (
  events: any,
  ownerKey: string,
  id: any,
  todayStr: string,
) => {
  const ev = events
    .filter(
      (a: any) => a[ownerKey] === id && a.date && a.date.slice(0, 10) >= todayStr,
    )
    .sort(
      (a: any, b: any) =>
        a.date.localeCompare(b.date) ||
        (a.time || "").localeCompare(b.time || ""),
    )[0];
  return ev ? ev.date.slice(0, 10) + (ev.time || "99:99") : null;
};
